<template>
  <div style="width:100%; height:100%;">
    <el-row>
      <el-col :span="20">
        <el-input v-model="searchInput" @keyup.enter.native="basicSearch();clear()">
          <template slot="prepend">
            <div @click="show = !show" class="search-label">
              高级搜索
              <i :class="show?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
            </div>
          </template>
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="basicSearch();clear()" style="height: 50px; background-color: #006f6f; border-color: #006f6f;">全站搜索</el-button>
      </el-col>
    </el-row>
      <el-card v-show="show">
        <el-form label-width="100px">
          <el-form-item label="数据集">
            <el-select size="mini" v-model="year" placeholder="时间" filterable clearable>
              <el-option value="2020年 下半年" label="2023年"></el-option>
            </el-select>
            <el-divider direction="vertical"></el-divider>
            <el-select size="mini" placeholder="省" filterable clearable v-model="dataset.path.provinceCode" @change="selectProvince">
              <el-option v-for="item in dataset.ops.provinces" :key="item.code" :value="item.code" :label="item.name"></el-option>
            </el-select>
            <el-divider direction="vertical"></el-divider>
            <el-select size="mini" placeholder="市" filterable clearable v-model="dataset.path.cityCode" @change="selectCity">
              <el-option v-for="item in dataset.ops.cities" :key="item.code" :value="item.code" :label="item.name"></el-option>
            </el-select>
            <el-divider direction="vertical"></el-divider>
            <el-select size="mini" placeholder="提供部门" filterable clearable allow-create v-model="dataset.path.department" @change="selectDepartment">
              <el-option v-for="item in dataset.ops.departments" :key="item.code" :value="item.code" :label="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开放条件">
            <el-radio-group v-model="free.val">
              <el-radio v-for="item in free.options" :key="item.val" :label="item.val">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="主题">
            <el-select size="mini" v-model="subject.vals" multiple>
              <el-option v-for="item in subject.options" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" size="medium" @click="advancedSearch();clear()"  style="background-color: #76be69; border-color: #76be69;">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-card>
  </div>
</template>

<script>
import { getProvinces, getCities, getDepartments } from '@/api/search'
export default {
  data () {
    return {
      show: false,
      free: {
        val: '-1',
        options: [
          {val: '-1', label: '全部'},
          {val: '1', label: '无条件开放'},
          {val: '0', label: '有条件开放'}
        ]
      },
      searchInput: '',
      dataset: {
        path: {
          provinceCode: '',
          province: '',
          cityCode: '',
          city: '',
          department: ''
        },
        ops: {
          provinces: [],
          cities: [],
          departments: []
        }
      },
      year: '',
      subject: {
        vals: [],
        options: ['教育科技', '社会民生', '信用服务', '财税金融', '其他', '文化休闲', '卫生健康', '资源环境', '社保就业', '机构团体', '经贸工商', '公共安全', '交通出行', '城建住房', '农业农村']
      }
    }
  },
  mounted () {
    getProvinces({}).then(({data}) => {
      this.dataset.ops.provinces = data
    })
  },
  methods: {
    clear () {
      this.searchInput = ''
      this.dataset.path = {
        provinceCode: '',
        province: '',
        cityCode: '',
        city: '',
        department: ''
      }
      this.free.val = '-1'
      this.subject.vals = []
      this.show = false
    },
    basicSearch () {
      const params = {
        query: this.searchInput,
        province: this.dataset.path.provinceCode,
        city: this.dataset.path.cityCode,
        department: this.dataset.path.department,
        subject: this.subject.vals,
        free: this.free.val
      }
      this.$emit('search', params)
    },
    advancedSearch () {
      const params = {
        province: this.dataset.path.provinceCode,
        city: this.dataset.path.cityCode,
        department: this.dataset.path.department,
        subject: this.subject.vals,
        free: this.free.val
      }
      this.$emit('search', params)
    },
    selectProvince (val) {
      if (val !== '') {
        this.dataset.path.province = this.dataset.ops.provinces.find(x => x.code === val).name
      }
      // this.advancedSearch()
    },
    selectCity (val) {
      if (val !== '') {
        this.dataset.path.city = this.dataset.ops.cities.find(x => x.code === val).name
      }
      // this.advancedSearch()
    },
    selectDepartment (val) {
      if (val !== '') {
        this.dataset.path.department = val
      }
      // this.advancedSearch()
    }
  },
  watch: {
    'dataset.path.provinceCode' (val) {
      this.dataset.path.cityCode = ''
      if (val === '') {
        this.dataset.ops.cities = []
        return
      }
      getCities(this.dataset.path).then(({data}) => {
        this.dataset.ops.cities = data
      })
    },
    'dataset.path.cityCode' (val) {
      this.dataset.path.department = ''
      if (val === '') {
        this.dataset.ops.departments = []
        return
      }
      getDepartments(this.dataset.path).then(({data}) => {
        this.dataset.ops.departments = data
      })
    },
    'dataset.path.department' (val) {
    }},
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
.search-label {
  cursor: pointer
}
</style>



// WEBPACK FOOTER //
// src/pages/common/Search.vue